<template>
  <g>
    <foreignObject :x="x" :y="y" width="230" height="24">
      <input maxlength="15" ref="datainput" class="input is-small input-room" v-model="name" @keydown.enter="updateRoomNameKeyDown" @keydown.9="updateRoomNameKeyDown" @blur="updateRoomName"/>
    </foreignObject>
    <rect :x="x" :y="y" width="230" height="24" fill="transparent" @dblclick="focusInput"/>
  </g>
</template>

<script>
export default {
  name: 'RoomName',
  componentName: 'RoomName',
  props: ['x', 'y', 'room'],
  data () {
    return {
      name: null,
    }
  },
  methods: {
    focusInput () {
      this.$refs.datainput.focus()
    },
    updateRoomNameKeyDown (e) {
      if (e.keyCode !== 13 && e.keyCode !== 9) return
      this.updateRoomName()
      e.srcElement.blur()
    },
    updateRoomName () {
      let updateRoom = this.room
      updateRoom.name = this.name
      this.$store.dispatch('virtualOffice/updateVirtualOfficeRoom', updateRoom)
    }
  },
  created () {
    this.name = this.room.name
  }
}
</script>

<style lang="scss" scoped>
.input-room {
  background: rgba(0, 0, 0, 0);
  border: none;
  color: white;
  font-size: 14px;
  font-weight: 600;
  border-radius: 0;
  width: 240px;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/VirtualOffice/Room/GreenGrassOfficeR/RoomName.vue